import { render, staticRenderFns } from "./DraggableList.vue?vue&type=template&id=6d4f1a80&scoped=true"
import script from "./DraggableList.vue?vue&type=script&lang=js"
export * from "./DraggableList.vue?vue&type=script&lang=js"
import style0 from "./DraggableList.vue?vue&type=style&index=0&id=6d4f1a80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4f1a80",
  null
  
)

export default component.exports